module.exports = __webpack_public_path__ + "img/back exposed 10mm zipper length.0e3c7d8a.png";